import React from 'react';
import { Checkbox, FormControlLabel, FormGroup } from '@mui/material';

export interface CheckboxWithLabelProps {
	mainLabel: React.ReactNode;
	subLabel?: React.ReactNode;
	checked: boolean | null;
	onChange: (checked: boolean | null) => void;
	disabled?: boolean;
	threeState?: boolean;
	className?: string;
}

export default function CheckboxWithLabel({
	mainLabel,
	subLabel,
	checked,
	onChange,
	disabled = false,
	threeState = false,
	className = ''
}: CheckboxWithLabelProps) {
	const handleCheckboxChange = (
		event: React.ChangeEvent<HTMLInputElement>
	) => {
		if (threeState) {
			// Cycle: true -> null -> false -> true
			if (checked === true) {
				onChange(null);
			} else if (checked === null) {
				onChange(false);
			} else {
				onChange(true);
			}
		} else {
			// Normal boolean cycle: true -> false -> true
			onChange(event.target.checked);
		}
	};

	return (
		<FormGroup>
			<FormControlLabel
				control={
					<Checkbox
						disabled={disabled}
						className={className}
						checked={checked === true}
						indeterminate={checked === null}
						onChange={handleCheckboxChange}
					/>
				}
				label={
					<div
						style={{
							display: 'flex',
							flexDirection: 'column',
							padding: '4px 0'
						}}
					>
						<span style={{ fontSize: '1rem', lineHeight: 1.2 }}>
							{mainLabel}
						</span>
						{!!subLabel && (
							<span
								style={{
									fontSize: '0.75rem',
									color: disabled
										? 'rgba(0, 0, 0, 0.26)'
										: 'rgba(0, 0, 0, 0.54)',
									marginTop: 2
								}}
							>
								{subLabel}
							</span>
						)}
					</div>
				}
			/>
		</FormGroup>
	);
}
